import { onboardingMeta } from "@clockwise/web-commons/src/util/local-storage";
import { OnboardingType, OnboardingTypeSource } from "@components/onboarding-nux/OnboardingNUX.d";

export * from "@clockwise/web-commons/src/util/local-storage";

export const setOnboardingMetaLocalStorage = (
  onboardingType: OnboardingType,
  onboardingTypeSource?: OnboardingTypeSource,
) => {
  onboardingMeta.clear();
  onboardingMeta.set("onboardingType", onboardingType);
  onboardingTypeSource && onboardingMeta.set("onboardingTypeSource", onboardingTypeSource);
};
